import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Talleres', href: '#producto' },
    { label: 'Reportes', href: '#reportes' },
    { label: 'Planes', href: '#planes' },
    { label: 'Contacto', href: '#contacto' },
  ];

  const scrollToSection = (hash) => {
    setIsMenuOpen(false);
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#0A0817]/90 backdrop-blur-xl border-b border-white/5 shadow-lg'
          : 'bg-transparent'
      }`}
      data-testid="main-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-18 py-4">
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img
              src="https://customer-assets.emergentagent.com/job_verso-autoreports/artifacts/b11ds7pz_3.png"
              alt="VERSO SOFTECH"
              className="h-10 w-auto"
            />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="text-[#A8A3B8] hover:text-white text-sm font-medium transition-colors duration-200 font-body"
              >
                {link.label}
              </button>
            ))}
            <Button
              onClick={() => window.open('https://app.versosoftech.com', '_blank')}
              className="gradient-forge text-white font-medium rounded-lg px-6 py-2.5 text-sm hover:opacity-90 transition-opacity shadow-lg shadow-[#4F46FF]/20"
              data-testid="header-cta-demo"
            >
              Pide tu DEMO
            </Button>
          </nav>

          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-[#0A0817]/95 backdrop-blur-xl border-t border-white/5">
          <div className="px-4 py-6 space-y-1">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="block w-full text-left text-[#A8A3B8] hover:text-white text-sm font-medium py-3 transition-colors"
              >
                {link.label}
              </button>
            ))}
            <Button
              onClick={() => { setIsMenuOpen(false); window.open('https://app.versosoftech.com', '_blank'); }}
              className="w-full gradient-forge text-white font-medium rounded-lg py-3 mt-4 text-sm"
              data-testid="mobile-cta-demo"
            >
              Pide tu DEMO
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
